export default __webpack_public_path__ + "static/reimbursement-submitted-8da15c6302e20db92047241b1c8e7bd9.svg";